export const notificationServer = {
  
  url: 'https://demo-nodejs-pulse.synapture.fr'
   // url: 'https://nodejs-interne.synapture.fr'
   //url:'https://pulse.synapture.fr'
   //url: 'http://localhost:3011'
};
